import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type AppPollingSortOption = "newest" | "oldest" | "questionAsc" | "questionDesc";

export const DEFAULT_APP_POLLING_SORT_OPTION: AppPollingSortOption = "newest";

const OPTIONS: SortOption<AppPollingSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "questionAsc", label: "Question (A-Z)" },
  { value: "questionDesc", label: "Question (Z-A)" },
];

export function appPollingSortOptionLabel(option: AppPollingSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function appPollingSortOptionToParams(option: AppPollingSortOption): {
  sortBy: "created_at" | "question";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "created_at", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "created_at", sortOrder: "ASC" };
    case "questionAsc":
      return { sortBy: "question", sortOrder: "ASC" };
    case "questionDesc":
      return { sortBy: "question", sortOrder: "DESC" };
  }
}

export default function SortAppPollingPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: AppPollingSortOption;
  setSortOption: (option: AppPollingSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort App Polling"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
